import { render, staticRenderFns } from "./CustomerDropdown.vue?vue&type=template&id=482d3088&"
import script from "./CustomerDropdown.vue?vue&type=script&lang=js&"
export * from "./CustomerDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDropdown.vue?vue&type=style&index=0&id=482d3088&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports